var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrolltopWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 841,
    height: 841,
    viewBox: "0 0 841 841",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1871_1248)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 841,
    height: 841,
    rx: 420.5,
    fill: "#1F2F60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.352 -17.1323C-2.7576 8.71774 -165.908 508.878 149.962 762.508C396.412 960.408 770.622 831.248 845.722 526.198C914.692 246.028 692.982 -35.6723 402.352 -17.1323ZM568.332 432.228C538.952 427.528 492.802 360.378 466.442 342.568V603.788C466.442 604.778 463.632 616.708 462.992 618.778C453.302 650.378 410.372 659.488 388.602 634.498C386.692 632.308 378.342 617.398 378.342 616.078V340.528L294.422 423.578C253.022 454.018 202.902 404.008 231.802 363.008L387.612 207.408C415.012 188.938 441.602 195.298 465.472 215.498C514.442 256.938 558.132 314.048 606.802 356.888C637.132 388.148 611.132 439.068 568.332 432.228Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1871_1248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 841,
    height: 841,
    rx: 420.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrolltopWhite);
export default __webpack_public_path__ + "static/media/Scrolltop_white.1c2130303299ef56a6eb86be0e6060b0.svg";
export { ForwardRef as ReactComponent };